import { Outlet, createFileRoute } from '@tanstack/react-router';
import { guardSection } from '../../shell/guard.ts';

// Tasks section (plan §9): the list at /tasks and each task page at /tasks/$taskId share the gate.
export const Route = createFileRoute('/_authed/tasks')({
  beforeLoad: guardSection('/tasks'),
  component: Outlet,
});
